import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiAiChatHelperService } from '@fi-shared/fi-ai-chat/fi-ai-chat-helper.service';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';

@Component({
    selector: 'fi-ai-chat',
    template: `
        @if ((isAvailable$ | async) && (isOpen$ | async)) {
            <fi-ai-chat-panel (close)="onClose()" />
        }
    `,
    styleUrls: ['./fi-ai-chat.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-ai-chat' },
    standalone: false,
})
export class FiAiChatComponent implements OnInit, OnDestroy {
    @HostBinding('class.shown') isShown = false;
    @HostBinding('style.right.px') rightOffset = FiAiChatHelperService.PANEL_DEFAULT_RIGHT;

    readonly isOpen$: Observable<boolean>;
    readonly isAvailable$: Observable<boolean>;

    constructor(
        private fiAiChatHelperService: FiAiChatHelperService,
        private fiChatHelperService: FiChatHelperService,
    ) {
        this.isOpen$ = this.fiAiChatHelperService.isOpen$;
        this.isAvailable$ = this.fiAiChatHelperService.isAvailable$;
    }

    ngOnInit(): void {
        this.isOpen$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((isOpen) => {
            this.isShown = isOpen;
        });
        this.fiChatHelperService.chatZoneWidth$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((width) => {
            this.rightOffset = Math.max(
                FiAiChatHelperService.PANEL_DEFAULT_RIGHT,
                width + FiAiChatHelperService.PANEL_GAP,
            );
        });
    }

    onClose(): void {
        this.fiAiChatHelperService.close();
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
